import { useEffect, useRef } from 'react';
import { useProxyStore } from '../store/proxy-store';
import { useProjectStore, useTargetId } from '../store/projectStore';
import { loadInterceptRulesForApplication } from '../utils/intercept-rules-storage';

export function useInterceptRulesHydration() {
  const selectedTarget = useProjectStore((state) => state.selectedTarget);
  const targetId = useTargetId();
  const currentTargetId = useProxyStore((state) => state.currentTargetId);
  const replaceInterceptRulesForApplication = useProxyStore(
    (state) => state.replaceInterceptRulesForApplication,
  );

  const previousApplicationIdRef = useRef<string | null>(null);

  const resolvedTargetId =
    selectedTarget?.id || targetId || currentTargetId || null;

  useEffect(() => {
    if (!selectedTarget?.id || !resolvedTargetId) {
      if (previousApplicationIdRef.current !== null) {
        previousApplicationIdRef.current = null;
        replaceInterceptRulesForApplication([]);
      }

      return;
    }

    const applicationId = selectedTarget.id;
    const isAppSwitch = previousApplicationIdRef.current !== applicationId;

    if (isAppSwitch) {
      previousApplicationIdRef.current = applicationId;
      replaceInterceptRulesForApplication([], { hydrationPending: true });
    }

    replaceInterceptRulesForApplication(
      loadInterceptRulesForApplication(applicationId),
    );
  }, [
    selectedTarget?.id,
    resolvedTargetId,
    replaceInterceptRulesForApplication,
  ]);
}
